// 微信式底部导航栏。只在移动端（<=640px）显示，样式见 css/wechat.css。
//
// 挂载位置很关键：放在 #sidepanel 里面，而不是 #app-container。
// 因为 tinode-web.jsx 在移动端打开会话时根本不渲染 #sidepanel，
// 所以 tab 栏会跟着自动消失 —— 正好是微信的行为，不用额外维护状态。
import React from 'react';

export default class BottomTabbar extends React.PureComponent {
  render() {
    const {tabs, active, onNavigate} = this.props;
    return (
      <nav id="bottom-tabbar">
        {tabs.map(t =>
          <a key={t.id} href="#" className={t.id === active ? 'active' : null}
            onClick={e => {e.preventDefault(); onNavigate(t.view);}}>
            <i className="material-icons">{t.icon}</i>
            <span>{t.label}</span>
          </a>
        )}
      </nav>
    );
  }
}
